import { render, staticRenderFns } from "./mypage-layout.vue?vue&type=template&id=1f135576&scoped=true&"
import script from "./mypage-layout.vue?vue&type=script&lang=js&"
export * from "./mypage-layout.vue?vue&type=script&lang=js&"
import style0 from "./mypage-layout.vue?vue&type=style&index=0&id=1f135576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f135576",
  null
  
)

export default component.exports